import { Button } from "@studyplus/boron-ui";
import { Field, Form } from "formik";
import { FC } from "react";
import { Link } from "react-router-dom";
import { Modal } from "../../../../../components/atoms/Modal";
import { SingleDatePickerField } from "../../../../../components/atoms/SingleDatePickerField";
import { ApiErrorInterface } from "../../../../../interfaces/ApiErrorResponseInterface";
import { SectionStay } from "../../../useFetchSectionStays";
import { ApiErrors } from "./ApiErrors";
import styles from "./styles.scss";

interface UpdateModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  stay: SectionStay;
  isSubmitting: boolean;
  apiErrors: ApiErrorInterface[];
}

export const UpdateModal: FC<UpdateModalProps> = ({
  isOpen,
  onRequestClose,
  stay,
  isSubmitting,
  apiErrors,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className={styles.modal}
    >
      <Modal.Header onClose={onRequestClose}>
        <h1>
          <Link to={`/students/${stay.student.id}`}>
            {stay.student.fullName}
          </Link>
          の入退室記録
        </h1>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <ApiErrors apiErrors={apiErrors} />
          <div className={styles.form_row}>
            <div className={styles.input_group}>
              <label htmlFor={`sectionStay-${stay.id}__date`}>日付</label>
              <Field
                id={`sectionTag-${stay.id}__date`}
                name="date"
                component={SingleDatePickerField}
                className={styles.input__date}
              />
            </div>
          </div>
          <div className={styles.form_row}>
            <div className={styles.input_group}>
              <label htmlFor={`sectionStay-${stay.id}__enteredAt`}>
                入室時間
              </label>
              <div className={styles.input__time_wrapper}>
                <Field
                  id={`sectionTag-${stay.id}__enteredAt`}
                  name="enteredAt"
                  type="time"
                  className={styles.input__time}
                />
              </div>
            </div>
            <div className={styles.input_group}>
              <label htmlFor={`sectionStay-${stay.id}__exitedAt`}>
                退室時間
              </label>
              <Field
                id={`sectionTag-${stay.id}__exitedAt`}
                name="exitedAt"
                type="time"
                className={styles.input__time}
              />
            </div>
          </div>
          <div className={styles.form_row__button}>
            <Button
              disabled={isSubmitting}
              type="submit"
              className={styles.btn}
            >
              入退室記録を更新
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
